import { lazyImport } from '@forest/utils';
import { Navigate } from 'react-router-dom';

const { Login } = lazyImport(() => import('@/features/auth'), 'Login');

export const publicRoutes = [
  {
    path: '/login',
    element: <Login />,
  },
  { path: '*', element: <Navigate to="/login" /> },
];
